<template>
    <div class="pos-check-select">
        <div
            class="pos-check-select__check"
            v-for="(option, i) in options"
            :key="i"
        >
            <input
                type="checkbox"
                :id="uuid(i)"
                :value="option.id"
                :checked="isActive(option.id)"
                @change="handleCheck(option.id)"
            >
            <label :for="uuid(i)">
                {{ title(option) }}
            </label>
        </div>
    </div>
</template>

<script>
import uuid from "../mixins/uuid";
import selectable from "../mixins/selectable";

export default {
    name: "ButtonSelect",
    mixins: [
        uuid,
        selectable
    ],
    props: {
        options: {
            type: Array,
            default: () => []
        },
        title: {
            type: Function,
            default: (s) => s
        }
    }
}
</script>